/* Values need to be initialized to allow easy iteration */
export enum UserRole {
    ADMIN = 'ADMIN',
    MEMBER = 'MEMBER',
    MPK = 'MPK',
    MPK_GSM_PRIVILEGE = 'MPK_GSM_PRIVILEGE',
    SAKP_MUNICIPALITY_GUEST = 'SAKP_MUNICIPALITY_GUEST',
    SAKP_MUNICIPALITY_EMPLOYEE = 'SAKP_MUNICIPALITY_EMPLOYEE',
    SAKP_MUNICIPALITY_MANAGER = 'SAKP_MUNICIPALITY_MANAGER',
    SAKP_CONTRACTOR_GUEST = 'SAKP_CONTRACTOR_GUEST',
    SAKP_CONTRACTOR_EMPLOYEE = 'SAKP_CONTRACTOR_EMPLOYEE',
    SAKP_CONTRACTOR_MANAGER = 'SAKP_CONTRACTOR_MANAGER',
    SAKP_ADMIN = 'SAKP_ADMIN'
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AdminSettingsRoles = {
    ...UserRole,
    DISABLED: 'DISABLED'
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ServiceSettingsRoles = {
    SERVICE: 'SERVICE',
    ...AdminSettingsRoles
};
